<template>
    <div>
        <slot></slot>
        <div class="invalid-feedback" :class="{'d-block':!!error}">
            {{ error }}
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default {
        inject: {
            form: { default: new Vue() }
        },
        props : {
            name: {
                type: String,
                require: true
            },
        },
        data() {
            return {
                error: null
            }
        },
        methods: {
            updateInput(cb) {
                const input = this.$el.querySelector('.form-control');
                if(input) {
                    cb(input);
                }
            },
            handleError(errors) {
                if(this.name in errors) {
                    this.error = errors[this.name][0];
                    this.updateInput(input => input.classList.add('is-invalid'));
                }
            },
            handleClear() {
                this.error=null;
                this.updateInput(input => input.classList.remove('is-invalid'));
            }
        },
        mounted() {
            this.form.$on('error', errors=>this.handleError(errors));
            this.form.$on('submitting', ()=>this.handleClear());
            this.form.$on('success', ()=>this.handleClear());
        }
    }
</script>